module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.show) ? _c('div', {
    staticClass: "c-oembed"
  }, [(_vm.oembedData.oembedIs360 && _vm.unsupported) ? _c('a', {
    staticClass: "c-oembed__fallback-image",
    style: ('background-image:url(' + _vm.oembedData.fallbackImage.sizes.bandara_medium + ')'),
    attrs: {
      "href": _vm.oembedData.videoUrl,
      "target": "_blank",
      "rel": "noopener"
    }
  }, [(_vm.isSafariOnOsx) ? _c('span', [_vm._v(_vm._s(_vm.localizedNotSupportedText))]) : _c('span', [_vm._v(_vm._s(_vm.localizedOpenYouTubeText))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "c-oembed__container"
  }, [_c('div', {
    directives: [{
      name: "append",
      rawName: "v-append",
      value: (_vm.oembedData.oembed),
      expression: "oembedData.oembed"
    }]
  })])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-be9135ae"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEmbed.vue
// module id = 278
// module chunks = 0